import { render, staticRenderFns } from "./DashboardWidgetUrlaub.vue?vue&type=template&id=364e6283&scoped=true"
import script from "./DashboardWidgetUrlaub.vue?vue&type=script&lang=js"
export * from "./DashboardWidgetUrlaub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364e6283",
  null
  
)

export default component.exports